import React, { useRef } from 'react';

import { BODY, HAIR, TOP, BOTTOM, PET, ACCESSORY } from '../../../services/utils/boomer';
import BoomerImg from '../../../images/store/boomer.png';
import Hair from '../../../images/store/hair.png';
import Top from '../../../images/store/top.png';
import Bottoms from '../../../images/store/bottoms.png';
import Pet from '../../../images/store/pet.png';
import Accessories from '../../../images/store/accessories.png';
import ArrowLeft from '../../../images/arrow_left.png';
import ArrowRight from '../../../images/arrow_right.png';
import SpecialStore from '../../../images/special_store.png';
import Backdrop from '../../../images/backdrop.png';

const Categories = ({ inventoryType, onSelectCategory, selectedCategory }) => {
    const categoryList = useRef(null);
    const categories = [
        { type: 'special_store', label: 'Special Store', image: SpecialStore, imageClass: 'store__category-special', imageOnly: true },
        { type: BODY, label: 'Skins', image: BoomerImg, imageClass: 'store__category-boomer' },
        { type: HAIR, label: 'Hair', image: Hair },
        { type: TOP, label: 'Tops', image: Top },
        { type: BOTTOM, label: 'Bottoms', image: Bottoms },
        { type: PET, label: 'Pets', image: Pet },
        { type: ACCESSORY, label: 'Accessories', image: Accessories },
        { type: 'backdrop', label: 'Backdrop', image: Backdrop }
    ];

    const scrollCategories = direction => {
        if (categoryList.current) {
            categoryList.current.scrollBy({
                behavior: 'smooth',
                left: direction * 250
            });
        }
    };

    return (
        <div className="store__categories" aria-label="Item categories">
            <button className="store__category-arrow" onClick={() => scrollCategories(-1)} aria-label="Scroll categories left">
                <img src={ArrowLeft} alt="" />
            </button>
            <div className="store__category-list" ref={categoryList}>
                {categories.filter(category => inventoryType !== 'owned' || category.type !== 'special_store').map(category => (
                    <button
                        key={category.type}
                        onClick={() => onSelectCategory(category.type)}
                        className={`store__category-tab ${selectedCategory === category.type ? 'store__category-tab--active' : ''}`}
                        aria-label={category.label}
                        aria-pressed={selectedCategory === category.type}
                    >
                        {!category.imageOnly && <span className="store__category-name">{category.label}</span>}
                        <img
                            alt=""
                            src={category.image}
                            className={category.imageClass || 'store__category-img'}
                        />
                    </button>
                ))}
            </div>
            <button className="store__category-arrow" onClick={() => scrollCategories(1)} aria-label="Scroll categories right">
                <img src={ArrowRight} alt="" />
            </button>
        </div>
    );
}

export default Categories;
